import React from 'react';
import AdminMainContainer from './adminmaincontainer'; // Adjust this path accordingly if the main container is in the same folder

const AdminPanel = () => {
    return (
        <div style={{ display: 'flex' }}>
            <AdminMainContainer />
        </div>
    );
};

export default AdminPanel;
